<style scoped lang="less">
.updoc{
    padding-top: 40px;
    padding-left: 0px;
    width: 960px;
    margin: auto;
    h1{
        color: #333333;
        padding-top: 0px;
        font-size: 24px;
        margin: 0;
    }
    ul{
        padding: 0;
        margin: 0;
        li{
            padding-left: 0;
            border-bottom:1px solid #cccccc;
            padding-bottom: 30px;
            h3{
                color: #333333;
                padding-bottom: 40px;
                padding-top: 50px;
                margin: 0;
                font-size: 18px;
                line-height: 1.1;
                span{
                    padding-right: 60px;
                }
            }
            p{
                color: #333333;
                line-height: 40px;
            }
            &:last-child{
                border: none;
            }
        }
        
    }
}
</style>
<template>
    <div class="updoc">
        <h1>快应用 SDK版本更新日志</h1>
        <ul>
            <li v-for="(item,index) in list" :key="index">
                <h3><span>版本：{{item.version}}</span><span>发布时间：{{item.publish_time}}</span></h3>
                <p v-html="item.log"></p>
            </li>
        </ul>
    </div>
</template>
<script>
	import { axiosGetsdk } from '../../../axios/axios.js'
	export default{
		name:'sdkdoc',
		data(){
			return{
                list:[]
            }
		},
		mounted(){
			this.getDoc()
		},
		methods:{
			getDoc(){
				axiosGetsdk('/home/sdk/typelist?os_type=3').then(res=>{
                    if(res.data.error_code == 0){
                        this.list = res.data.list
                    }
                })
			}
		}
	}
</script>





// WEBPACK FOOTER //
// src/pages/NewHome/SDK/kyySDKUp.vue